import React from 'react';

import { useTranslation } from 'react-i18next';
import { Text, VStack, Divider, Box } from '@gluestack-ui/themed';
import ResourceItem from './components/ResourceItem';

const ResourceSidebar = ({ resources, thumbnails, ...props }) => {
  const { t } = useTranslation();

  // Sort resources by position (0-based index), putting items without position at the end
  const sortedResources = React.useMemo(() => {
    return [...resources].sort((a, b) => {
      // If both have position, sort by position
      if (a.position !== null && a.position !== undefined && b.position !== null && b.position !== undefined) {
        return a.position - b.position;
      }
      // If only a has position, it comes first
      if (a.position !== null && a.position !== undefined) return -1;
      // If only b has position, it comes first
      if (b.position !== null && b.position !== undefined) return 1;
      // If neither has position, maintain original order
      return 0;
    });
  }, [resources]);

  if (!sortedResources.length) {
    return (
      <Text size="sm" color="$textSubtle">
        {t('student.task.resourcePanel.no-resources')}
      </Text>
    );
  }

  return (
    <VStack testID="resource-sidebar" {...props} space="sm">
      {sortedResources.map((resource, index) => (
        <React.Fragment key={resource.id}>
          <ResourceItem resource={resource} thumbnail={resource.thumbnailUrls?.small} />
        </React.Fragment>
      ))}
    </VStack>
  );
};

export default ResourceSidebar;
